import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import LetterTile from './letter-tile.jsx'
import HashNavigation from '../lib/navigation.js';
import AccessMode from '../tinode/access-mode'
import { IconChat } from "../icons/svg/index.js";

class ContactMessage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectChat = this.handleSelectChat.bind(this);
  }

  handleSelectChat() {
    const { topicContact: topicName } = this.props
    HashNavigation.navigateTo(HashNavigation.removeUrlParam(window.location.hash, 'tab'));
    const topic = this.props.tinode.getTopicByName(topicName, {
      isCreateWhenNotExist: true,
    });
    if (topic) {
      topic.acs = new AccessMode({
        given: 'JRWPASDO',
        want: 'JRWPASDO',
        mode: 'JRWPASDO',
      })
      topic._cachePutSelf()
    }
    this.props.onCreateTopic(topicName);
    this.props.onTopicSelected(topicName);
  }

  render() {
    return (
      <div className="contact-message-container">
        <div className="contact-container">
          <div className="contact-avatar-container">
            <div className="avatar-box">
              <LetterTile
                tinode={this.props.tinode}
                avatar={this.props.avatar || true}
                topic={this.props.topic}
                title={this.props.name} />
            </div>
          </div>
          <div className="contact-info">
            <div className="contact-name">{this.props.name}</div>
            <div className="contact-phone">{this.props.phone}</div>
          </div>
        </div>
        <button
          className="contact-button-chat"
          onClick={this.handleSelectChat}
        >
          <i><IconChat /></i><FormattedMessage
            id="dialog_send_message"
            defaultMessage={"Send message"}
          />
        </button>
      </div>
    )
  }
}

export default injectIntl(ContactMessage);